namespace GeniuzPOS.Purchase {
    export interface PoInvoiceReceiveDtRow {
        Id?: number;
        SysDocNo?: string;
        SupplierId?: string;
        ShopId?: string;
        WhsId?: string;
        LineItemNo?: number;
        SkuCode?: string;
        SkuDesc?: string;
        UnitCost?: number;
        UnitChange?: UnitChangeEnumFg;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        LastPurUnitPrice?: number;
        Qty?: number;
        BeforeDiscAmt?: number;
        DiscText?: string;
        DiscAmt?: number;
        ItemNetAmt?: number;
        AlocalteDiscAmt?: number;
        ItemAmt?: number;
        SalesVatTypes?: string;
        VatType?: string;
        VatCode?: string;
        VatRate?: number;
        ItemVatAmt?: number;
        ItemExVatAmt?: number;
        ItemExciseTaxAmt?: number;
        ItemNetCostValue?: number;
        ExpDate?: string;
        Remark?: string;
        StkQty?: number;
        PiRefDocNo?: string;
        PiLineId?: number;
        QtyUse?: number;
        UseFg?: number;
    }

    export namespace PoInvoiceReceiveDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoInvoiceReceiveDt';
        export const lookupKey = 'Purchase.PoInvoiceReceiveDt';

        export function getLookup(): Q.Lookup<PoInvoiceReceiveDtRow> {
            return Q.getLookup<PoInvoiceReceiveDtRow>('Purchase.PoInvoiceReceiveDt');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            SupplierId = "SupplierId",
            ShopId = "ShopId",
            WhsId = "WhsId",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            UnitCost = "UnitCost",
            UnitChange = "UnitChange",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            LastPurUnitPrice = "LastPurUnitPrice",
            Qty = "Qty",
            BeforeDiscAmt = "BeforeDiscAmt",
            DiscText = "DiscText",
            DiscAmt = "DiscAmt",
            ItemNetAmt = "ItemNetAmt",
            AlocalteDiscAmt = "AlocalteDiscAmt",
            ItemAmt = "ItemAmt",
            SalesVatTypes = "SalesVatTypes",
            VatType = "VatType",
            VatCode = "VatCode",
            VatRate = "VatRate",
            ItemVatAmt = "ItemVatAmt",
            ItemExVatAmt = "ItemExVatAmt",
            ItemExciseTaxAmt = "ItemExciseTaxAmt",
            ItemNetCostValue = "ItemNetCostValue",
            ExpDate = "ExpDate",
            Remark = "Remark",
            StkQty = "StkQty",
            PiRefDocNo = "PiRefDocNo",
            PiLineId = "PiLineId",
            QtyUse = "QtyUse",
            UseFg = "UseFg"
        }
    }
}
